import { useMemo } from 'react';
import { LanguageTranslator } from '../LanguageTranslator';

const useTranslator = (locale = 'en') => {
  const translator = useMemo(() => {
    if (locale) {
      return LanguageTranslator.getTranslations(locale);
    }
    return {};
  }, [locale]);

  return translator;
};

export default useTranslator;
